<template>
  <div class="pl-4 pr-4 pb-4 pt-1">
    <v-layout row align-start justify-start>
      <v-flex>
        <v-subheader class="pl-0 pt-0"
          ><v-icon>message</v-icon>
          <span class="pl-2">Interaktiv guide</span></v-subheader
        >
      </v-flex>
      <v-flex> </v-flex>
    </v-layout>
    <v-layout row align-start justify-start>
      <v-flex>
        <div
          v-for="(description, index) in activeZoomLevelDescriptions"
          :key="index"
          v-html="description.text"
        ></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "LayerZoomLevelDescription",
  data: function() {
    return {};
  },
  computed: {
    ...mapState(["zoom"]),
    activeZoomLevelDescriptions: function() {
      return this.zoomLevelDescriptions.filter(zoomLevelDescription => {
        return (
          this.zoom >= zoomLevelDescription.from &&
          this.zoom <= zoomLevelDescription.to
        );
      });
    }
  },
  props: {
    zoomLevelDescriptions: Array
  }
};
</script>

<style lang="scss" scoped></style>
